import { ChoferService } from './../services/chofer.service';
import { CiudadService } from './../services/ciudad.service';
import { ClienteService } from './../services/cliente.service';
import { Component, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import ICredencialUsuario from '../models/credencial';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { NoordinariosService } from '../services/noordinarios.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ICiudad } from '../models/ciudad';
import { ICliente } from '../models/cliente';
import { ITipoServicio } from '../models/tiposervicio';
import { ITipoAsistenciaPagada } from '../models/tipoasistencia';
import { IHorariosAsistenciaPagada } from '../models/tipohorariosap';
import { ITipoServiciosAsistenciaPagada } from '../models/tiposervicioap';
import { IDataEnviarAP } from '../models/data_enviar_ap';
import { IDataEnviarTU } from '../models/data_enviar_tu';
import { IDataEnviarCapacitacion } from '../models/data_enviar_capacitacion';
import { IDataEnviarCertificacion } from '../models/data_enviar_certificacion';
import { IMovNoOrdinarios } from '../models/mov_noordinarios';
import { AuthService } from '../services/auth.service';
import { IChofer } from '../models/chofer';
import { IChoferesActivos } from '../models/choferes_activos';
import { ITipoTransporte } from '../models/tipotransporte';
import { TipotransporteService } from '../services/tipotransporte.service';
import { Ipuestos } from '../models/Ipuestos';
import { ConfunidadService } from '../services/confunidad.service';
import { IConfiguracionUnidad } from '../models/confUnidad';

import { UnidadtransporteService } from '../services/unidadtransporte.service';
import { InumEconomico } from '../models/numEconomico';
import { IResultadoGeneral } from '../models/resultadogeneral';
import * as saveAs from 'file-saver';
import { Observable, timeout } from 'rxjs';
import { IAdmProveedor } from '../models/admProveedor';
import { IRutasDispCapacitacion } from '../models/rutasDispCapacitacion';
import { ITabuladoresCapacitacion } from '../models/tabuladoresCapacitacion';
import { IDataEnviarRU } from '../models/data_enviar_ru';
import { IMes } from '../models/mes';

@Component({
  selector: 'app-noordinarios',
  templateUrl: './noordinarios.component.html',
  styleUrls: ['./noordinarios.component.scss']
})
export class NoordinariosComponent {
  @ViewChild('dt1') dt!: Table;
  @ViewChild('dt2') dt2!: Table;
  lstChofer: IChofer[] = [];
  lstMovimientos: IMovNoOrdinarios[] = [];
  lscargarConfunidadService:IConfiguracionUnidad[]=[];
  lstCiudades: ICiudad[] = [];
  lstCliente: ICliente[] = [];
  lstTipoServicio: ITipoServicio[]=[];
  lstTipoAsistencia: ITipoAsistenciaPagada[]=[];
  lsPuestos: Ipuestos[]=[];
  lsNumEconomico: InumEconomico []=[];
  lstHorariosAsistenciaPagada:IHorariosAsistenciaPagada[]=[];
  lstTipoServiciosAsistenciaPagada:ITipoServiciosAsistenciaPagada[]=[];
  lstTipoCapacitacion = [{id: 1,nombre: 'Capacitación sin Ruta - Teoría'},{id: 2,nombre: 'Capacitación con Ruta - Práctica'}];
  lstTipoPuesto = [{id: 1, nombre:'DRIVER'},{id:2,nombre:'AUXILIAR'}]
  lstRutasDispCapacitacion: IRutasDispCapacitacion[] = [];
  selectedInfoExtra: any;
  lstTabCapacitacion: ITabuladoresCapacitacion[] = [];
  //CATALOGOS POR FEFINIR
  lstChoferesDisponibles:IChoferesActivos[]=[];
  //FIN CATALOGOS POR DEFINIR
  fecha_dia: any = null;
  mostrarbtnLimpiarFiltro: boolean = false;
  user: ICredencialUsuario = {};
  loading: boolean = false;
  loading_reporte1: boolean = false;
  dspTipoServicio: boolean = false;
  clv_operacion:number=0;
  clv_btn_eliminar:number=0;
  clv_boton_registrar:number=0;
  btnHabilitarSpinner: boolean = false;
  habilitar_un_dia:boolean = false;
  ButtonExportExcel:boolean = false;
  editarRuta: boolean = false;
  text_subHeader: string = '';
  //validaciones de pantallas
  clv_AP: boolean = false;
  clv_TU: boolean = false;
  clv_CA: boolean = false;
  clv_CE: boolean = false;
  clv_RU: boolean = false;
  habilitaRutas: boolean = false;
  dgRutas: boolean = false;
  dgInfoExtra: boolean = false;
  selectedNoOrdinario: any;
  desc_ruta: string = '';
  text_headerInfoExtra: string = '';
  text_subHeaderInfoExtra: string = '';
  dbsReportes:boolean=false;
  fec_dia_reporte: any = null;
  fec_fin_reporte: any = null;
  botonExcel: boolean=false;
  reportes = [
    {
      id_reporte: 1,
      titulo: 'Reporte No Ordinarios',
      descripcion: 'Consulta de No Ordinarios fecha y/o fecha fin.',
      fec_inicio: null,
      fec_fin: null,
      ciudad: null,
      mes: null,
      anio: null
    }
  ];
  meses: IMes[] = [
      { num_mes: 1, nombre: "Enero" },
      { num_mes: 2, nombre: "Febrero" },
      { num_mes: 3, nombre: "Marzo" },
      { num_mes: 4, nombre: "Abril" },
      { num_mes: 5, nombre: "Mayo" },
      { num_mes: 6, nombre: "Junio" },
      { num_mes: 7, nombre: "Julio" },
      { num_mes: 8, nombre: "Agosto" },
      { num_mes: 9, nombre: "Septiembre" },
      { num_mes: 10, nombre: "Octubre" },
      { num_mes: 11, nombre: "Noviembre" },
      { num_mes: 12, nombre: "Diciembre" }];
  gestionForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl(0, [
      Validators.required
    ])
    //id_tipo: new FormControl(null,[Validators.required])
  });
  APForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl({ value: 0, disabled: true }, [
      Validators.required
    ]),
    id_tipo_asistencia_pagada: new FormControl(0, [Validators.required]),
    id_horario: new FormControl(0, [Validators.required]),
    id_servicio_prestado: new FormControl(0, [Validators.required]),
    cod_chofer: new FormControl(0, [Validators.required]),
    id_ciudad_hm: new FormControl(0, [Validators.required]),
    id_cliente: new FormControl(0,[Validators.required]),
    //agrega cambio itzael
    clave_configuracionUnidad: new FormControl(0,[Validators.required]),
    id_puesto: new FormControl(0,[Validators.required] ),
  });

  TUForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl({ value: 0, disabled: true }, [Validators.required]),
    cod_chofer: new FormControl(0, [Validators.required]),
    id_ciudad_hm_colab: new FormControl({ value: 0, disabled: true }),
    id_ciudad_hm: new FormControl(0, [Validators.required]),
    id_cliente: new FormControl(0, [Validators.required]),
    num_economico: new FormControl('', [Validators.required]),
    imp_viaticos: new FormControl(0,[Validators.required,Validators.min(0),Validators.max(450)])
  });

  CAForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl({ value: 0, disabled: true }, [Validators.required]),
    id_tipo: new FormControl(null,[Validators.required]),
    cod_chofer: new FormControl(null, [Validators.required]),
    id_ciudad_hm: new FormControl(null, [Validators.required]),
    id_cliente: new FormControl(-2, [Validators.required]),
    // id_puesto: new FormControl({value: null,disabled: true},[Validators.required]),
    id_puesto: new FormControl(null,[Validators.required]),
    clave_configuracionUnidad: new FormControl(null,[Validators.required]),
    imp_viaticos: new FormControl({value:0, disabled: true},[Validators.required]),
    imp_hospedaje: new FormControl({value:0, disabled: true},[Validators.required]),
    imp_sueldo: new FormControl({value:0, disabled: true},[Validators.required]),
    desc_ruta: new FormControl(''),
    id_ruta: new FormControl(null,[Validators.required])
  });

  CEForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl({ value: 0, disabled: true }, [
      Validators.required
    ]),
    cod_chofer: new FormControl(0, [Validators.required]),
    id_ciudad_hm: new FormControl(0, [Validators.required]),
    id_cliente: new FormControl(0, [Validators.required]),
    clave_configuracionUnidad: new FormControl(0,[Validators.required]),
    id_puesto: new FormControl(0,[Validators.required])
  });

  RUForm: FormGroup = new FormGroup({
    id_tipo_servicio: new FormControl({ value: 0, disabled: true }, [Validators.required]),
    cod_chofer: new FormControl(0, [Validators.required]),
    id_puesto: new FormControl(0,[Validators.required]),
    puesto: new FormControl({ value:null ,disabled:true }),
    id_ciudad_hm_colab: new FormControl({ value: 0, disabled: true }),
    id_ciudad_hm: new FormControl({value:0,disabled:true}, [Validators.required]),
    id_cliente: new FormControl(0, [Validators.required]),
    id_unidad_transporte: new FormControl(0, [Validators.required]),
    num_economico: new FormControl('', [Validators.required]),
    clave_configuracionUnidad: new FormControl(0),
    desc_config: new FormControl({value:'',disabled:true}),
    imp_viaticos: new FormControl(0,[Validators.required,Validators.min(0),Validators.max(450)])
  });
  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private noordinariosService: NoordinariosService,
    private clienteService: ClienteService,
    private confunidadService: ConfunidadService,
    private ciudadService: CiudadService,
    private unidadtransporteService: UnidadtransporteService,
    private choferService: ChoferService,
    private auth: AuthService) {
    this.cargarInformacionUsuario();

    this.gestionForm.controls['id_tipo_servicio'].valueChanges.subscribe(data => {
      //this.disableAll();
      this.clv_AP = false;
      this.clv_CA = false;
      this.clv_CE = false;
      this.clv_TU = false;
      this.clv_RU = false;

      if (data==null) {
        //cuando se limpie
        this.resetearPantallasAMostrar();
        this.resetearFormularios(data);
      }

      if(data != 6)
        this.changeDisabledCiudad(0);

      if(data == 3)
      {
        this.CAForm.controls['id_tipo'].setValidators([Validators.required]);
        this.CAForm.controls['id_cliente'].setValue(-2);

        this.lscargarConfunidadService.map(x => {
          x.disabled = true;
        });
      }
      else
      {
        if(this.CAForm.controls['id_tipo'].value != null)
        {
          this.CAForm.controls['id_tipo'].setValidators([]);
          this.CAForm.controls['id_tipo'].setValue(null);
        }

        this.lscargarConfunidadService.map(x => {
            x.disabled = false;
        });
      }
      //else this.resetearFormularios();
    });

    this.CAForm.controls['id_tipo'].valueChanges.subscribe( data => {
      if(data != null)
      {
        let i = this.lstTipoCapacitacion.find(x => x.id == data);
        this.text_subHeader = typeof i !== 'undefined' ? i.nombre : '';

        if(data == null)
        {
          this.CAForm.get('imp_viaticos')?.setValue(0);
          this.CAForm.get('imp_hospedaje')?.setValue(0);
          this.CAForm.get('imp_sueldo')?.setValue(0);
        }

        if(data == 2)
        {
          this.habilitaRutas = true;
          this.CAForm.controls['id_ruta'].setValidators([Validators.required]);
          this.CAForm.get('id_ruta')?.setValue(null);
        }
        else
        {
          this.habilitaRutas = false;
          this.CAForm.get('imp_viaticos')?.setValue(0);
          this.CAForm.get('imp_hospedaje')?.setValue(0);
          this.CAForm.controls['id_ruta'].setValidators([]);
          this.CAForm.get('id_ruta')?.setValue(null);
        }
      }
      else
      {
        this.habilitaRutas = false;
        this.clv_CA = false;
      }
    });

    this.APForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let idx= this.lstChoferesDisponibles.findIndex(x => x.cod_chofer == data)
        if(typeof idx !== 'undefined' && idx != null )
        {
          this.APForm.controls['id_puesto'].setValue(this.lstChoferesDisponibles[idx].id_puesto);
          this.APForm.controls['id_ciudad_hm'].setValue(this.lstChoferesDisponibles[idx].id_ciudad_hm);
        }
      }
    });
    this.TUForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let idx= this.lstChoferesDisponibles.findIndex(x => x.cod_chofer == data)
        this.TUForm.controls['id_ciudad_hm_colab'].setValue(this.lstChoferesDisponibles[idx].id_ciudad_hm);
      }
    });
    this.CEForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let idx= this.lstChoferesDisponibles.findIndex(x => x.cod_chofer == data)
        if(typeof idx !== 'undefined' && idx != null )
        {
          this.CEForm.controls['id_puesto'].setValue(this.lstChoferesDisponibles[idx].id_puesto);
          this.CEForm.controls['id_ciudad_hm'].setValue(this.lstChoferesDisponibles[idx].id_ciudad_hm);
        }
      }
    });
    this.CAForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let idx= this.lstChoferesDisponibles.findIndex(x => x.cod_chofer == data)
        if(typeof idx !== 'undefined' && idx != null )
        {
          this.CAForm.controls['id_puesto'].setValue(this.lstChoferesDisponibles[idx].id_puesto);
          this.CAForm.controls['id_ciudad_hm'].setValue(this.lstChoferesDisponibles[idx].id_ciudad_hm);
        }

        if(this.gestionForm.controls['id_tipo_servicio'].value == 3)
          {
            this.CAForm.get('imp_viaticos')?.setValue(0);
            this.CAForm.get('imp_hospedaje')?.setValue(0);
            this.CAForm.get('imp_sueldo')?.setValue(0);
            this.CAForm.get('clave_configuracionUnidad')?.setValue(null);
          }
      }
      else
      {
        this.CAForm.controls['id_puesto'].setValue(null);
        this.CAForm.controls['id_ciudad_hm'].setValue(null);
        this.CAForm.controls['clave_configuracionUnidad'].setValue(null);
        this.CAForm.controls['imp_sueldo'].setValue(0);
        this.CAForm.controls['imp_viaticos'].setValue(0);
        this.CAForm.controls['imp_hospedaje'].setValue(0);
        this.CAForm.controls['id_ruta'].setValue(null);
        this.CAForm.controls['desc_ruta'].setValue('');
      }
    });
    this.CAForm.controls['id_ciudad_hm'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let tipo_transporte = this.lstCiudades.find(x => x.id == data)?.clave_tipoTransporte;

        let id_tipo =
          typeof this.CAForm.get('id_tipo')?.value !== 'undefined' ||
            this.CAForm.get('id_tipo')?.value != null ? this.CAForm.get('id_tipo')?.value : 0;

        if(typeof tipo_transporte !== 'undefined' || tipo_transporte != null)
          this.lscargarConfunidadService.map(x => {
            if(x.id_tipo_transporte == tipo_transporte)
              x.disabled = false;
            else
              x.disabled = true;
          });

        if(data != 0 && id_tipo == 2)
          this.editarRuta = true;
      }
    });
    this.CAForm.controls['clave_configuracionUnidad'].valueChanges.subscribe(data => {
      if(data != null && data != undefined)
      {
        let id_ciudad_hm =
        typeof this.CAForm.get('id_ciudad_hm')?.value !== 'undefined' ||
          this.CAForm.get('id_ciudad_hm')?.value != null ? this.CAForm.get('id_ciudad_hm')?.value : 0;

        if(typeof data !== 'undefined' && data != null && id_ciudad_hm != 0)
          this.sueldosTabCapacitacion(id_ciudad_hm,data);
      }
    });
    this.RUForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      if(data != null && data != undefined && data != 0 )
      {
        let idx= this.lstChoferesDisponibles.findIndex(x => x.cod_chofer == data)
        let chof = this.lstChoferesDisponibles[idx];
        this.RUForm.controls['id_ciudad_hm_colab'].setValue(chof.id_ciudad_hm);
        let id_puesto = chof.id_puesto <= 2 && chof.id_puesto != 0 ? chof.id_puesto : 1;
        let pst = this.lstTipoPuesto.find(x => x.id == id_puesto)?.nombre
        this.RUForm.controls['puesto'].setValue(pst !== 'undefined' ? pst : '');
        this.RUForm.controls['id_puesto'].setValue(chof.id_puesto);
      }
    });
    this.RUForm.controls['id_unidad_transporte'].valueChanges.subscribe(data => {
      if(data != null && data != undefined && data != 0 )
      {
        let unidad= this.lsNumEconomico.find(x => x.id_unidad_transporte == data);
        let num_economico = unidad != undefined || unidad != null ? unidad.num_economico : '';
        let tipo_transporte = unidad != undefined || unidad != null ? unidad.clave_tipoTransporte : 0;
        let id_ciudad = unidad != undefined || unidad != null ? unidad.id_ciudad_hm : 0;
        let config = unidad != undefined || unidad != null ? unidad.clave_configuracionUnidad : 0;
        let desc_config = this.lscargarConfunidadService.findIndex(x => x.clave_configuracionUnidad == config);

        this.RUForm.controls['num_economico'].setValue(num_economico);
        this.RUForm.controls['id_ciudad_hm'].setValue(id_ciudad);
        this.RUForm.controls['clave_configuracionUnidad'].setValue(config);
        this.RUForm.controls['desc_config'].setValue(this.lscargarConfunidadService[desc_config].nombre);
        this.changeDisabledCiudad(tipo_transporte);
      }
    });
  }

  changeDisabledCiudad(tipo_transporte:number){
    if(tipo_transporte == 0)
      this.lstCiudades.map(x =>{x.disabled = false});
    else
      this.lstCiudades.map(x => {
        if(x.clave_tipoTransporte == tipo_transporte)
          x.disabled = false;
        else
          x.disabled = true;
      });
  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  ngOnInit(): void {
    this.getListaDeChoferes_Filtro();
    this.getListaDeClientes();
    this.cargarListadoCiudades();
    this.cargarListadoTipoServicioAP();
    this.cargarConfunidadService();
    this.cargarListaPuestos();
    this.CargarNumeroEconomico();
    this.cargarListadoHorarios();
    this.cargarListadoTipoAsistencia();
    this.inicializarFechasFormateadas();
    this.cargarListadoNoOrdinarios();
  }

  enableAPForm(){
    this.APForm.controls['id_tipo_asistencia_pagada'].enable();
    this.APForm.controls['id_horario'].enable();
    this.APForm.controls['id_servicio_prestado'].enable();
    this.APForm.controls['cod_chofer'].enable();
    this.APForm.controls['id_ciudad_hm'].enable();
    this.APForm.controls['id_cliente'].enable();
    this.APForm.controls['clave_configuracionUnidad'].enable();
    this.APForm.controls['id_puesto'].enable();
  }

  enableTUForm()
  {
    this.TUForm.controls['cod_chofer'].enable();
    this.TUForm.controls['id_ciudad_hm'].enable();
    this.TUForm.controls['id_cliente'].enable();
    this.TUForm.controls['num_economico'].enable();
    this.TUForm.controls['imp_viaticos'].enable();
  }

  enableCAForm(){
    this.CAForm.controls['cod_chofer'].enable();
    this.CAForm.controls['id_ciudad_hm'].enable();
    this.CAForm.controls['id_cliente'].enable();
    this.CAForm.controls['id_puesto'].enable();
    this.CAForm.controls['clave_configuracionUnidad'].enable();
  }

  enableCEForm(){
    this.CEForm.controls['cod_chofer'].enable();
    this.CEForm.controls['id_ciudad_hm'].enable();
    this.CEForm.controls['id_cliente'].enable();
    this.CEForm.controls['id_puesto'].enable();
    this.CEForm.controls['clave_configuracionUnidad'].enable();
  }

  enableRUForm()
  {
    this.RUForm.controls['cod_chofer'].enable();
    this.RUForm.controls['id_ciudad_hm'].enable();
    this.RUForm.controls['id_cliente'].enable();
    this.RUForm.controls['num_economico'].enable();
    this.RUForm.controls['imp_viaticos'].enable();
  }


  exportarExcel() {
    this.ButtonExportExcel = true;
    this.loading_reporte1 = true;
    if (this.fecha_dia == undefined || this.fecha_dia == '1900-01-01') {
      this.mostrarDialogoInformativo('<b>Aviso</b> Es necesario seleccionar <b>Fecha</b> a Filtrar');
    } else {
      if (this.lstMovimientos.length == 0 || typeof this.lstMovimientos.length === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion Filtrada para la fecha <b>'+this.fecha_dia+'</b>');
        this.loading_reporte1 = false;
        this.ButtonExportExcel = false;
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.mapeaExcel(this.lstMovimientos));
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "Servicios_NoOrdinarios_Fecha");
        });
        setTimeout(() => {
          this.ButtonExportExcel = false;
          this.loading_reporte1 = false;
        }, 1000);
      }
    }
  }

  mapeaExcel(movs :IMovNoOrdinarios[]): [any]
  {
    var inf: any = [];
    movs.forEach(x=>{
        inf.push(
          {
            No_Ordinario: x.desc_tipo_servicio,
            Tipo_Asistencia: x.desc_tipo_asistencia_pagada,
            Horario: x.desc_horario,
            Tipo_Servicio_Prestado: x.desc_tipo_servicio_prestado,
            Codigo_Chofer:x.cod_chofer,
            Nombre_Chofer:x.nombre_completo,
            Puesto:x.desc_puesto,
            Ciudad_Operacion:x.desc_ciudad,
            Ruta:x.desc_ruta,
            Cliente:x.desc_cliente,
            Numero_Economico:x.num_economico,
            Configuracion_Unidad:x.desc_confUnidad,
            Fecha:x.fecha,
            Usuario_Ultima_Modificacion:x.nom_ult_mod
          }
        )
      }
    )
    return inf;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_export_" + dateFormat + EXCEL_EXTENSION);
  }

  getListaDeChoferes_Filtro() {
    this.loading=true;
    this.noordinariosService.getChoferesActivos().subscribe((resp) => {
      this.lstChoferesDisponibles = resp;
      setTimeout(() => {
        this.loading=false;
      }, 1000);
    },
    (error)=> {
      this.loading=false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Choferes');
    });
  }

  cargarListadoNoOrdinarios() {
    this.noordinariosService.getListadoNoOrdinarios().subscribe((resp) => {
      this.lstTipoServicio = resp;

      let idx_canceladas = this.lstTipoServicio.findIndex(x => x.id == 5);
      //let idx_rescate = this.lstTipoServicio.findIndex(x => x.id == 6);
      this.lstTipoServicio[idx_canceladas].disabled  = true;
      //this.lstTipoServicio[idx_rescate].disabled  = true;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <No Ordinarios>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  cargarListadoTipoAsistencia() {
    this.noordinariosService.getListadoTipoAsistencia().subscribe((resp) => {
      this.lstTipoAsistencia = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <TipoAsistencia>', detail: 'Contacte al Administrador del Sitio' });
      });
  }
  cargarListaPuestos() {
    this.choferService.getPuestos().subscribe((resp) => {
      this.lsPuestos = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <TipoAsistencia>', detail: 'Contacte al Administrador del Sitio' });
      });
  }
  //itzael numero economico
  CargarNumeroEconomico() {
    this.unidadtransporteService.getListadoNumEconomicoSimplified().subscribe((resp) => {
      this.lsNumEconomico = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <TipoAsistencia>', detail: 'Contacte al Administrador del Sitio' });
      });
  }


  cargarListadoHorarios() {
    this.noordinariosService.getListadoHorariosAsistenciaPagada().subscribe((resp) => {
      this.lstHorariosAsistenciaPagada = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Horarios>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  cargarListadoTipoServicioAP() {
    this.noordinariosService.getListadoTipoServicioAP().subscribe((resp) => {
      this.lstTipoServiciosAsistenciaPagada = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <TipoServiciosAsistenciaPagada>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  cargarListadoCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }
//itzael consumir las listas de tipo transporte
cargarConfunidadService() {
  this.confunidadService.getListadoConfUnidades().subscribe((resp) => {

    this.lscargarConfunidadService = resp;
    // conf = resp;
    // conf.map(x =>{
    //   this.lscargarConfunidadService.push({
    //     clave_configuracionUnidad: x.clave_configuracionUnidad,
    //     nombre: x.nombre,
    //     disabled: false});
    // })

  },
    (error) => {
      this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
    });
}
//---------------------------fin itzael
  getListaDeClientes() {
    this.loading = true;
    this.clienteService.getListadoClientes().subscribe((resp) => {
      this.lstCliente = resp;
      //agregar HappyMile como Cliente
      this.lstCliente.unshift({
        id_cliente: -2,
        nombre: 'HAPPYMILE',
        fec_registro: '1900-01-01',
        clv_activo: 1,
        id_categoria:0,
        desc_categoria:''
      });
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar <Listado de Clientes>');
      });
  }

  inicializarFechasFormateadas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.fecha_dia = dateFormat;
  }

  obtenerFechaMomento(): string {
    let fecha: any;
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    fecha = getYear + "-" + getMonth + "-" + getDay;
    return fecha;
  }

  cargarInformacionPorFecha(fecha: string, fecha_fin: string) {
    let fecha_fin_cast = fecha_fin == null ? '1900-01-01' : fecha_fin;
    this.lstMovimientos = [];
    this.loading = true;
    if (fecha == null) {
      this.mostrarDialogoInformativo('<b>Aviso</b> Es necesario seleccionar <b>Fecha</b> de Operación a Filtrar');
    } else {
      this.noordinariosService.getListadoDeMovimientosFecha(fecha, this.user.cod!).subscribe((resp) => {
        this.lstMovimientos = resp;
        if (!this.lstMovimientos.length || typeof this.lstMovimientos === 'undefined') {
          //
          this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion con la Fecha Seleccionada de Servicios <b>No Ordinarios</b>.');
        } else {
          //asignar el tipo de permiso al usuario
          this.clv_operacion = this.lstMovimientos[0].clv_operacion;
          //this.clv_btn_eliminar=this.lstMovimientos[0].clv_btn_eliminar;
          if(this.clv_operacion==1||this.clv_operacion==3){
            //revisar permisos de usuario normal, solo puede ingresar información de la fecha del dia
            let fecha_ruta = new Date(this.lstMovimientos[0].fecha + 'T00:00:00');

            if (this.clv_operacion == 1) {
              //Se agrega el tiempo para que no reste un dia por ser tipo Date();
              let fecha_final_dia=new Date(this.obtenerFechaMomento()+'T00:00:00');

              if (fecha_final_dia.getTime() == fecha_ruta.getTime()) {
                this.habilitar_un_dia = true;
              } else {
                this.habilitar_un_dia = false;
              }
            }
          }
          //filtro el arreglo para eliminar el registro default
          this.lstMovimientos = this.lstMovimientos.filter((data) => data.id_tipo_servicio != 0);
        }
        let data={
          cod_usuario:this.user.cod,
          fecha:fecha
        }
        this.noordinariosService.postVerificarPermisosRegistrar(data).subscribe((resp)=>{
          this.clv_boton_registrar=resp[0].btn_habilitar_registrar
        })
        this.mostrarbtnLimpiarFiltro = true;
        this.loading = false;
      },
        (error) => {
          this.loading = false;
          this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Informacion de Operacion Diaria');
        });
    }
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
  }

  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }

  LimpiarFiltro() {
    this.lstMovimientos = [];
    this.fecha_dia = null;
    this.limpiarFiltrosTabla();
    this.mostrarbtnLimpiarFiltro = false;
    this.loading = false;
  }

  limpiarFiltrosTabla() {
    this.dt.clear();
  }

  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  guardarInformacionAsistenciaPagada() {
    this.btnHabilitarSpinner=true;
    let data_enviar : IDataEnviarAP = {
      id_tipo_servicio: this.APForm.get('id_tipo_servicio')?.value,
      id_tipo_asistencia_pagada: this.APForm.get('id_tipo_asistencia_pagada')?.value,
      id_horario: this.APForm.get('id_horario')?.value,
      id_servicio_prestado: this.APForm.get('id_servicio_prestado')?.value,
      cod_chofer: this.APForm.get('cod_chofer')?.value,
      id_ciudad_hm: this.APForm.get('id_ciudad_hm')?.value,
      id_cliente: this.APForm.get('id_cliente')?.value==null ? 0:this.APForm.get('id_cliente')?.value,
      cod_usuario: this.user.cod!,
      fecha: this.fecha_dia,
      clave_configuracionUnidad: this.APForm.get('clave_configuracionUnidad')?.value ,
      id_puesto:this.APForm.get('id_puesto')?.value

    }
    this.noordinariosService.agregarAsistenciaPagada(data_enviar).subscribe((resp)=>{
      var respuesta=resp;
      if(respuesta.clv_estatus==-2){
        this.confirmationService.confirm({
          message: respuesta.messageDetails,
          header: 'Informativo',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
            this.messageService.clear();
          },
          key: "sinInformacionDialog"
        });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }

      setTimeout(() => {
        this.btnHabilitarSpinner =false;
      }, 1000);
    },
    (error)=> {
      this.btnHabilitarSpinner=false;
      this.messageService.add({ severity: 'error', summary: 'Error en <guardar AP>', detail: 'Contacte al Administrador del Sitio' });
    });
  }

  guardarInformacionTrasladoUnidad() {
    this.btnHabilitarSpinner =true;
    let data_enviar : IDataEnviarTU = {
      id_tipo_servicio: this.TUForm.get('id_tipo_servicio')?.value,
      cod_chofer: this.TUForm.get('cod_chofer')?.value,
      id_ciudad_hm: this.TUForm.get('id_ciudad_hm')?.value,
      id_cliente: this.TUForm.get('id_cliente')?.value == null ? 0 : this.TUForm.get('id_cliente')?.value,
      cod_usuario: this.user.cod!,
      fecha: this.fecha_dia,
      idx: 0,
      id_tipo_asistencia_pagada: 0,
      id_horario: 0,
      id_servicio_prestado: 0,
      //agregar una doble validacion itzael
      num_economico:this.TUForm.get('num_economico')?.value == null ? 0 : this.TUForm.get('num_economico')?.value.num_economico,
      imp_viaticos:this.TUForm.get('imp_viaticos')?.value
    }
    // Se comento por parte de operación, que si es posible que se asigne a la misma ciudad de OP
    // if(data_enviar.id_ciudad_hm == this.TUForm.get('id_ciudad_hm_colab')?.value )
    // {
    //   this.messageService.add({ severity: 'warn', summary: 'Revise Informacion', detail: 'No se puede guardar una ciudad destino igual al origen del colaborador.' });
    //   this.btnHabilitarSpinner = false;
    // }
    // else
      this.noordinariosService.agregarTrasladoUnidad(data_enviar).subscribe((resp)=>{
        var respuesta=resp;
      if(respuesta.clv_estatus==-2){
        this.confirmationService.confirm({
          message: respuesta.messageDetails,
          header: 'Informativo',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
            this.messageService.clear();
          },
          key: "sinInformacionDialog"
        });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
        setTimeout(() => {
          this.btnHabilitarSpinner =false;
        }, 1000);
      },
      (error)=> {
        this.btnHabilitarSpinner=false;
        this.messageService.add({ severity: 'error', summary: 'Error en <guardar Traslado de Unidad>', detail: 'Contacte al Administrador del Sitio' });
      });

  }
//itzael giardar capacitacion
  guardarInformacionCapacitacion() {
    this.btnHabilitarSpinner=true;
    let data_enviar : IDataEnviarCapacitacion = {
      id_tipo_servicio: this.CAForm.get('id_tipo_servicio')?.value,
      cod_chofer: this.CAForm.get('cod_chofer')?.value,
      id_ciudad_hm: this.CAForm.get('id_ciudad_hm')?.value,
      id_puesto: this.CAForm.get('id_puesto')?.value == null ? 0 : this.CAForm.get('id_puesto')?.value.id,
      clave_configuracionUnidad: this.CAForm.get('clave_configuracionUnidad')?.value ,
      id_cliente: this.CAForm.get('id_cliente')?.value == null ? 0 : this.CAForm.get('id_cliente')?.value,
      cod_usuario: this.user.cod!,
      fecha: this.fecha_dia,
      idx: 0,
      id_tipo_asistencia_pagada: 0,
      id_horario: 0,
      id_servicio_prestado: 0,
      imp_viaticos: this.CAForm.get('imp_viaticos')?.value == null ? 0 :this.CAForm.get('imp_viaticos')?.value,
      imp_hospedaje: this.CAForm.get('imp_hospedaje')?.value == null ? 0 :this.CAForm.get('imp_hospedaje')?.value,
      id_tipo_capacitacion: this.CAForm.get('id_tipo')?.value == null ? 0 :this.CAForm.get('id_tipo')?.value,
      id_ruta: this.CAForm.get('id_ruta')?.value == null ? 0 :this.CAForm.get('id_ruta')?.value
    }
    this.noordinariosService.agregarCapacitacion(data_enviar).subscribe((resp)=>{
      var respuesta=resp;
      if(respuesta.clv_estatus==-2){
        this.confirmationService.confirm({
          message: respuesta.messageDetails,
          header: 'Informativo',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
            this.messageService.clear();
          },
          key: "sinInformacionDialog"
        });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }else if(respuesta.clv_estatus == 0){
        this.messageService.add({ severity: 'error', summary: 'Error en <guardar Capacitacion>', detail: 'Contacte al Administrador del Sitio' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
/*
      let mssg: IResultadoGeneral = resp
      if(mssg.clv_estatus == -2)
        this.messageService.add({ severity: 'warn', summary: 'Revise Datos', detail: mssg.messageDetails });
      else if(mssg.clv_estatus == 0)
        this.messageService.add({ severity: 'error', summary: 'Error en <guardar Capacitacion>', detail: 'Contacte al Administrador del Sitio' });
      else
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });

      this.cancelarModalTipoServicio();
      this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');*/
      setTimeout(() => {
        this.btnHabilitarSpinner =false;
      }, 1000);
    },
    (error)=> {
      this.btnHabilitarSpinner=false;
      this.messageService.add({ severity: 'error', summary: 'Error en <guardar Capacitacion>', detail: 'Contacte al Administrador del Sitio' });
    });
  }
//certificacion itzael
  guardarInformacionCertificacion() {
    this.btnHabilitarSpinner=true;
    let data_enviar: IDataEnviarCertificacion = {
      id_tipo_servicio: this.CEForm.get('id_tipo_servicio')?.value,
      cod_chofer: this.CEForm.get('cod_chofer')?.value,
      id_ciudad_hm: this.CEForm.get('id_ciudad_hm')?.value,
      id_cliente: this.CEForm.get('id_cliente')?.value == null ? 0 : this.CEForm.get('id_cliente')?.value,
      clave_configuracionUnidad: this.CEForm.get('clave_configuracionUnidad')?.value ,
      id_puesto:this.CEForm.get('id_puesto')?.value,
      cod_usuario: this.user.cod!,
      fecha: this.fecha_dia,
      idx: 0,
      id_tipo_asistencia_pagada: 0,
      id_horario: 0,
      id_servicio_prestado: 0
    }

    this.noordinariosService.agregarCertificacion(data_enviar).subscribe((resp)=>{
      var respuesta=resp;

      if(respuesta.clv_estatus==-2){
        this.confirmationService.confirm({
          message: respuesta.messageDetails,
          header: 'Informativo',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
            this.messageService.clear();
          },
          key: "sinInformacionDialog"
        });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      setTimeout(() => {
        this.btnHabilitarSpinner =false;
      }, 1000);
    },
    (error)=> {
      this.btnHabilitarSpinner=false;
      this.messageService.add({ severity: 'error', summary: 'Error en <guardar Certificacion>', detail: 'Contacte al Administrador del Sitio' });
    });
  }

  guardarInformacionRescateUnidad() {
    this.btnHabilitarSpinner =true;
    let data_enviar : IDataEnviarRU = {
      id_tipo_servicio: this.RUForm.get('id_tipo_servicio')?.value,
      cod_chofer: this.RUForm.get('cod_chofer')?.value,
      id_ciudad_hm: this.RUForm.get('id_ciudad_hm')?.value,
      id_cliente: this.RUForm.get('id_cliente')?.value == null ? 0 : this.RUForm.get('id_cliente')?.value,
      id_puesto: this.RUForm.get('id_puesto')?.value,
      cod_usuario: this.user.cod!,
      fecha: this.fecha_dia,
      idx: 0,
      id_tipo_asistencia_pagada: 0,
      id_horario: 0,
      id_servicio_prestado: 0,
      //agregar una doble validacion itzael
      num_economico:this.RUForm.get('num_economico')?.value == null ? '' : this.RUForm.get('num_economico')?.value,
      imp_viaticos:this.RUForm.get('imp_viaticos')?.value
    }
    // Se comento por parte de operación, que si es posible que se asigne a la misma ciudad de OP
    // if(data_enviar.id_ciudad_hm == this.TUForm.get('id_ciudad_hm_colab')?.value )
    // {
    //   this.messageService.add({ severity: 'warn', summary: 'Revise Informacion', detail: 'No se puede guardar una ciudad destino igual al origen del colaborador.' });
    //   this.btnHabilitarSpinner = false;
    // }
    // else
      this.noordinariosService.agregarRescateUnidad(data_enviar).subscribe((resp)=>{
        var respuesta=resp;
      if(respuesta.clv_estatus==-2){
        this.confirmationService.confirm({
          message: respuesta.messageDetails,
          header: 'Informativo',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
            this.messageService.clear();
          },
          key: "sinInformacionDialog"
        });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarModalTipoServicio();
        this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
      }
        setTimeout(() => {
          this.btnHabilitarSpinner =false;
        }, 500);
      },
      (error)=> {
        this.btnHabilitarSpinner=false;
        this.messageService.add({ severity: 'error', summary: 'Error en <guardar Rescate de Unidad - Apoyo (Sin Ruta)>', detail: 'Contacte al Administrador del Sitio' });
      });

  }
  confirmarEliminar(idx: number,id_tipo_servicio: number,id_ruta:number) {
    let text_info = this.lstTipoServicio.find(x => x.id = id_tipo_servicio)?.nombre
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b> Eliminar </b> el registro de <b>' + text_info + '</b> ?',
      header: 'Confirmacion de Eliminación',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.eliminarNoOrdinario(idx,id_tipo_servicio,id_ruta);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            //prov.clv_activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Eliminado' });
            break;
          case ConfirmEventType.CANCEL:
            //prov.clv_activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Eliminado' });
            break;
        }
      }
    });
  }

  tpServicio(clv_btn_eliminar: number,id_tipo_servicio: number): string
  {
    let tp_servicio = this.lstTipoServicio.find(x => x.id == id_tipo_servicio)?.nombre.toUpperCase();
    let text_info = clv_btn_eliminar == 0 ? 'No se puede elminar '+tp_servicio : 'Eliminar '+tp_servicio;

    return text_info;
  }

  eliminarNoOrdinario(idx: number,id_tipo_servicio: number,id_ruta: number)
  {
    this.btnHabilitarSpinner=true;
    let data_enviar =
    {
      idx: idx,
      id_tipo_servicio: id_tipo_servicio,
      id_ruta: id_ruta,
      cod_usuario: this.user != undefined ? this.user.cod : '0999'
    }

    this.noordinariosService.earseNoOrdin(data_enviar).subscribe((resp) => {
      if(resp.clv_estatus == -2)
      {
        setTimeout(() => {
          this.btnHabilitarSpinner=false;
          this.messageService.add({ severity: 'warn', summary: 'Atención', detail: resp.messageDetails });
        }, 800);
      }
      else
      {
        setTimeout(() => {
          this.btnHabilitarSpinner=false;
          this.messageService.add({ severity: 'success', summary: 'Registro Eliminado', detail: 'La informacion se elimino de forma correcta.' });
          this.cargarInformacionPorFecha(this.fecha_dia, '1900-01-01')
        }, 800);
      }
    }, (error) => {
      this.btnHabilitarSpinner=false;
      this.messageService.add({ severity: 'error', summary: 'Error al eliminar Registro', detail: 'Contacte al Administrador del Sitio.' });
    });
  }


  mostrarModalTipoServicio(){
    var today = new Date();
    var getYear = today.getFullYear();
    var getMonth = ('0' + (today.getMonth() + 1)).slice(-2);
    var getDay = ('0' + today.getDate()).slice(-2);
    var dateFormat = getYear + "-" + getMonth + "-" + getDay; // Resultado: '2025-04-07'

    this.gestionForm.reset();

    //desactivar los items con id 1 ,2 y 3
    /*
    if(this.fecha_dia < dateFormat){

      [1,2,3].forEach(id => {
        let idx = this.lstTipoServicio.findIndex(x => x.id == id);
        if (idx !== -1) {
          this.lstTipoServicio[idx].disabled = true;
        }
      });
    }else{
      //volverlos a activar
      [1,2,3].forEach(id => {
        let idx = this.lstTipoServicio.findIndex(x => x.id == id);
        if (idx !== -1) {
          this.lstTipoServicio[idx].disabled = false;
        }
      });
    }*/
    this.dspTipoServicio = true;
  }

  cancelarModalTipoServicio() {
    this.dspTipoServicio = false;
    this.ocultarTodasPantallasServicios();
    //reiniciar formularios
    let num_opcion = this.gestionForm.get('id_tipo_servicio')?.value==null ? 0:this.gestionForm.get('id_tipo_servicio')?.value;
    this.resetearFormularios(num_opcion);
    this.gestionForm.reset();
  }

  ocultarTodasPantallasServicios() {
    this.clv_AP = false;
    this.clv_TU = false;
    this.clv_CA = false;
    this.clv_CE = false;
    this.clv_RU = false;
    //falta reiniciar los formularios

  }

  resetearPantallasAMostrar(){
    this.clv_AP = false;
    this.clv_TU = false;
    this.clv_CA = false;
    this.clv_CE = false;
    this.clv_RU = false;
  }

  resetearFormularios(num_opcion: number){
    switch(num_opcion)
    {
      case 1:
        this.APForm.reset();
        break;
      case 2:
        this.TUForm.reset();
        break;
      case 3:
        this.CAForm.reset();
        break;
      case 4:
        this.CEForm.reset();
        break;
      case 6:
        this.RUForm.reset();
        break;
      default:
        break;
    }
  }

  disableAll(){
    let num_opcion = this.gestionForm.get('id_tipo_servicio')?.value==null ? 0:this.gestionForm.get('id_tipo_servicio')?.value;

    switch(num_opcion)
    {
      case 1:
        this.APForm.disable();
        break;
      case 2:
        this.TUForm.disable();
        break;
      case 3:
        this.CAForm.disable();
        break;
      case 4:
        this.CEForm.disable();
        break;
      default:
        break;
    }
  }

  gestionPantallas() {
    let num_opcion = this.gestionForm.get('id_tipo_servicio')?.value==null ? 0:this.gestionForm.get('id_tipo_servicio')?.value;
    let id_tipo_capacitacion = this.CAForm.get('id_tipo')?.value==null ? 0:this.CAForm.get('id_tipo')?.value;
    this.resetearFormularios(num_opcion);

    switch (num_opcion) {
      case 1: {
        //Asistencia Pagada
        this.APForm.controls['id_tipo_servicio'].setValue(num_opcion);
        // this.APForm.controls['id_tipo_asistencia_pagada']
        this.clv_AP = true;
        this.clv_TU = false;
        this.clv_CA = false;
        this.clv_CE = false;
        this.clv_RU = false;
        this.enableAPForm();
      } break;
      case 2: {
        //Traslado de Unidad
        this.TUForm.controls['id_tipo_servicio'].setValue(num_opcion);
        this.TUForm.controls['imp_viaticos'].setValue(0);
        this.clv_AP = false;
        this.clv_TU = true;
        this.clv_CA = false;
        this.clv_CE = false;
        this.clv_RU = false;
        this.enableTUForm();
      } break;
      case 3: {
        //Capacitación
        this.CAForm.controls['id_tipo_servicio'].setValue(num_opcion);
        this.CAForm.controls['id_tipo'].setValue(id_tipo_capacitacion);
        this.CAForm.controls['id_cliente'].setValue(-2);
        this.clv_AP = false;
        this.clv_TU = false;
        this.clv_CA = true;
        this.clv_CE = false;
        this.clv_RU = false;
        this.enableCAForm();
      } break;
      case 4: {
        //Certificacion
        this.CEForm.controls['id_tipo_servicio'].setValue(num_opcion);
        this.clv_AP = false;
        this.clv_TU = false;
        this.clv_CA = false;
        this.clv_CE = true;
        this.clv_RU = false;
        this.enableCEForm();
      } break;
      case 6: {
        //Certificacion
        this.RUForm.controls['id_tipo_servicio'].setValue(num_opcion);
        this.RUForm.controls['imp_viaticos'].setValue(0);
        this.RUForm.controls['id_cliente'].setValue(-2);
        this.clv_AP = false;
        this.clv_TU = false;
        this.clv_CA = false;
        this.clv_CE = false;
        this.clv_RU = true;
        this.enableRUForm();
      } break;
      default: {
        this.mostrarDialogoInformativo('Servicio No Encontrado. Contacte al Administrador.');
      } break;
    }
  }

  validCapacitacion()
  {
    if(this.gestionForm.get('id_tipo_servicio')?.value == 3)
      return true;
    else
      return false;
  }

  validAceptar()
  {
    return this.gestionForm.controls['id_tipo_servicio'].value == 3 ? this.CAForm.controls['id_tipo'].value != null ? false : true : !this.gestionForm.valid;
  }

  validarGestionRutas()
  {
    let quest =
      this.CAForm.controls['cod_chofer'].value != null
      && this.CAForm.controls['id_puesto'].value != null
      && this.CAForm.controls['id_ciudad_hm'].value != null
      && this.CAForm.controls['clave_configuracionUnidad'].value != null ? true : false;

    return !this.validAceptar() ? quest ? false : true : true;
  }

  validForRuta()
  {
    if(this.CAForm.controls['cod_chofer'] != null
      )
      return true;
      else return false;
  }

  disabledTipoServicio()
  {

    if((!this.gestionForm.valid && this.gestionForm.get('id_tipo_servicio')?.value != 3 && this.CAForm.get('id_tipo')?.value == null && this.CAForm.dirty)
        ||( !this.gestionForm.valid && this.gestionForm.get('id_tipo_servicio')?.value == 3 && this.CAForm.get('id_tipo')?.value != null && this.CAForm.dirty))
      return true;
    else
      return false;
  }

  dirtyForm()
  {
    if(this.APForm.dirty||this.CAForm.dirty||this.CEForm.dirty||this.TUForm.dirty)
      return true;
    else
      return false;
  }

  sueldosTabCapacitacion(id_ciudad_hm: number,clave_configuracionUnidad: number){
    this.lstTabCapacitacion = [];

    this.noordinariosService.getTabCapacitacion(id_ciudad_hm,clave_configuracionUnidad,this.fecha_dia).subscribe((resp) => {
      if(resp.length > 0)
      {
        this.lstTabCapacitacion = resp;

        if(this.CAForm.controls['id_puesto'].value != null)
        {
          let val = this.lstTabCapacitacion.find(x => x.id == this.CAForm.controls['id_puesto'].value)?.imp_sueldo
          this.CAForm.controls['imp_sueldo'].setValue(val);
        }
      }else
      {
        this.messageService.add({ severity: 'error', summary: 'Error en <Cargar Listado Sueldo Tabulado Capacitacion>'
          , detail: "No fue posible cargar Listado Sueldo Tabulado Capacitacion." });
      }
    },
    (error) => {
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado Sueldo Tabulado Capacitacion.');
    });
  }

  mostrarRutasCapacitacion(){
    this.lstRutasDispCapacitacion = [];
    let id_ciudad_hm =
    typeof this.CAForm.get('id_ciudad_hm')?.value !== 'undefined' ||
      this.CAForm.get('id_ciudad_hm')?.value != null ? this.CAForm.get('id_ciudad_hm')?.value : 0;
    let id_puesto =
    typeof this.CAForm.get('id_puesto')?.value !== 'undefined' ||
      this.CAForm.get('id_puesto')?.value != null ? this.CAForm.get('id_puesto')?.value : 0;

    this.noordinariosService.getListRutasDispCapacitacion(id_ciudad_hm,id_puesto,this.fecha_dia).subscribe((resp) => {
      if(resp.length > 0){
        this.lstRutasDispCapacitacion = resp;
        setTimeout(() => {
          this.dgRutas = true;
        }, 600);
      }else
      {
        this.dgRutas = false;
        this.messageService.add({ severity: 'warn', summary: 'Atención'
          , detail: "No se encontraro Rutas para el dia "+this.fecha_dia+"." });
      }
    },
    (error) => {
      this.dgRutas = false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado Rutas.');
    });
  }
  cancelarDialogoRutas(){
    this.dgRutas = false;
  }
  applyFilterGlobal2($event: any, stringVal: any) {
    this.dt2.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  onRowSelectRuta(data: IRutasDispCapacitacion){
    if(data != null)
    {
      this.CAForm.get('desc_ruta')?.setValue(data.desc_ruta);
      this.CAForm.get('id_ruta')?.setValue(data.id_ruta);
      this.CAForm.get('imp_viaticos')?.setValue(data.imp_viaticos);
      this.CAForm.get('imp_hospedaje')?.setValue(data.imp_hospedaje);
    }
    else
      this.CAForm.get('desc_ruta')?.setValue('');


    this.dgRutas = false;
  }

  descRuta(){
    return this.CAForm.get('desc_ruta')?.value;
  };

  mostrarInfoExtra(data: any){
    this.selectedInfoExtra = data;
    this.text_headerInfoExtra = data.desc_tipo_servicio;

    if(data.id_tipo_servicio != 3)
      this.text_subHeaderInfoExtra = 'Informacion No Ordinario';
    else{
      let i = this.lstTipoCapacitacion.find(x => x.id == (data.id_ruta == 0 ? 1:2));

      this.text_subHeaderInfoExtra = typeof i !== 'undefined' ? 'Informacion No Ordinario - Capacitación' : 'Informacion No Ordinario';
    }
    this.dgInfoExtra = true;
  }

  inicializarFechasFormateadasReportes() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;

    //Reportes
    this.fec_fin_reporte = null;
  }

  abrirModalReportes() {
    this.dbsReportes = true;
    this.inicializarFechasFormateadasReportes();
  }
  rptNoOrdinarios(fec_dia_reporte: string, fec_fin_reporte: string) {
    let fecha_fin_cast = fec_fin_reporte == null ? '1900-01-01' : fec_fin_reporte;
    let tituloReporte = "NoOrdinarios";
    let fec_init = new Date(fec_dia_reporte);
    let fec_fin = new Date(fecha_fin_cast);
    if (fec_dia_reporte == null||(fecha_fin_cast!='1900-01-01' && fec_init>fec_fin)){ 
      this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> La <b>Fecha Fin</b> no puede ser menor que la <b>Fecha Inicial</b>');
      this.cancelarModalReportesIndividual();
    }else{
      this.noordinariosService.getRptNoOrdinario(fec_dia_reporte, fecha_fin_cast,this.user.cod)
      .subscribe((resp) => 
      {
          if (resp.length == 0) {
            this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
            this.cancelarModalReportesIndividual();
          } else {
            import("xlsx").then(xlsx => {
              const worksheet = xlsx.utils.json_to_sheet(resp);
              const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
              const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
              });
              let texto: string = fec_fin_reporte == '1900-01-01' || fec_fin_reporte == null ? '' : '_Al_' + fec_fin_reporte;
              this.saveAsExcelFile(excelBuffer, tituloReporte + '_' + fec_dia_reporte + texto);
            });
            setTimeout(() => {
              this.botonExcel = false;
              this.cancelarModalReportesIndividual();
            }, 1000);
          }
      },
      (error) => {
        this.botonExcel = false;
        this.fec_fin_reporte = null;
        this.cancelarModalReportesIndividual();
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Kilometraje.' });
      });
    }
  }

  verReporte(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any, mes: any, anio: any) {
    this.botonExcel=true;
    switch (id_reporte) {
      case 1:
        this.rptNoOrdinarios(fec_inicio,fec_fin)
        this.botonExcel=true;
        break;
      // case 2:
      //   this.exportarExcelKilometros(fec_inicio, fec_fin)
      //   break;
      // case 3:
      //   this.exportarExcelReporteNuevo(fec_inicio, fec_fin)
      //   break;
      // case 4:
      //   this.exportarExcelReporteAsignacion(fec_inicio, fec_fin, ciudad)
      //   break;
      // case 5:
      //   this.exportarMovimientosUrea(fec_inicio, fec_fin)
       // break;
    }
  }
 cancelarModalReportesIndividual() {
  this.botonExcel = false;
  this.reportes = this.reportes.map(rep => ({
    ...rep,
    fec_inicio: null,
    fec_fin: null,
    ciudad: null,
    mes: null,
    anio: null,
  }));}
  cancelarModalReportes() {
    this.reportes = this.reportes.map(rep => ({
      ...rep,
      fec_inicio: null,
      fec_fin: null,
      ciudad: null,
      mes: null,
      anio: null,
    }));
    this.dbsReportes = false;
    this.fec_dia_reporte = null;
    this.fec_fin_reporte = null;
  }

  cancelarDialogoInforExtra(){
    this.dgInfoExtra = false;
    this.selectedInfoExtra = {};
    this.text_subHeaderInfoExtra = '';
    this.text_headerInfoExtra = '';
  }

}
